import React from 'react';
import * as S from './style';

export default function CardEndereco({ dadosInputs }) {
  return (
    <S.CardInputs className="boxShadow">
      <S.CardInputsTitulo>Endereço</S.CardInputsTitulo>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>CEP:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.cep}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Logradouro:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.logradouro}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Complemento:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.complemento}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Número:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.numero}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Bairro:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.bairro}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Cidade:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.cidade}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Estado:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.estado}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>País:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.pais}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>
    </S.CardInputs>
  );
}
